import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, computed } from 'vue';
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'list-skeleton',
  setup(__props, { expose: __expose }) {
  __expose();

const route = useRoute();
const skeletonRows = ref(0);
const routeRows = computed(() => {
    const name = route.name;
    switch (name) {
        case 'search':
            return 30;
        case 'collect':
            return 30;
        default:
            return 0;
    }
})

watch(() => document.body.scrollHeight,
    (screen) => {
        const line = (screen - 60 - routeRows.value) / 32;
        skeletonRows.value = Math.floor(line) - 4;
    },
    {
        immediate: true,
    }
)


const __returned__ = { route, skeletonRows, routeRows }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})